import script from "./InternationalPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./InternationalPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./InternationalPhoneInput.vue?vue&type=style&index=0&id=676c2385&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676c2385"]])

export default __exports__